import { TopicCard as ServerTopicCard } from 'server/models/TopicCard';
import { TopicCardStatus } from 'server/enums/TopicCardStatus';

export { TopicCardData, TopicCardOptions } from 'server/models/TopicCard';

export class TopicCard extends ServerTopicCard {
    Status() {
        return this.DeniedDate() !== null ? TopicCardStatus.Denied :
            this.ConfirmedDate() !== null ? TopicCardStatus.Confirmed :
            TopicCardStatus.PendingReview;
    }
}


// WEBPACK FOOTER //
// ./data/models/TopicCard.ts